<template>
  <div class="ordinaryModify">
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="plainGoldSelectDialogVisible"
      :before-close="handleClose"
      z-index="1000"
    >
      <div class="ordinaryModifyChild">
        <div class="secBox">
          <div class="child">
            <div class="selb">
              <span>材质：</span>
              <el-select
                :popper-append-to-body="false"
                v-model="amendDuplication.texture"
                clearable
                @change="getPriceRange"
                placeholder=""
              >
                <el-option
                  v-for="item in optionsList.textureList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <div
                    class="cartTexture"
                    :class="amendDuplication.texture == item ? 'cartColor' : ''"
                  >
                    {{ item }}
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="selb">
              <span>金重：</span>
              <el-select
                v-model="amendDuplication.goldWeigh"
                :popper-append-to-body="false"
                @change="getPriceRange"
                clearable
                placeholder=""
              >
                <el-option
                  v-for="item in optionsList.mainStoneList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <div
                    class="cartMainStone"
                    :class="
                      amendDuplication.goldWeigh == item ? 'cartColor' : ''
                    "
                  >
                    {{ item }}
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="child">
            <!-- <div
              class="selb"
              v-if="
                optionsList.ringType === '1' || optionsList.ringType === '2'
              "
            >
              <span v-if="optionsList.ringType === '1'">手寸：</span>
              <span v-if="optionsList.ringType === '2'">链长：</span>
              <el-select
                :popper-append-to-body="false"
                v-model="amendDuplication.ringSize"
                @change="getPriceRange"
                clearable
                placeholder=""
              >
                <el-option
                  v-for="item in optionsList.handSizeList"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  <div
                    class="cartTexture"
                    :class="
                      amendDuplication.ringSize == item ? 'cartColor' : ''
                    "
                  >
                    {{ item }}
                  </div>
                </el-option>
              </el-select>
            </div> -->
            <div class="selb">
              <span>商品数量：</span>
              <el-input-number
                @keyup.enter.native="getPriceRange"
                @focus="btnFlag = true"
                @blur="onBlur"
                :min="1"
                :max="9999"
                @change="getPriceRange"
                v-model="amendDuplication.quantity"
              ></el-input-number>
            </div>
          </div>
          <div class="child">
            <!-- <div class="selb">
              <span>标签金额：</span>
              <div class="amountClass">{{ amendDuplication.labelPrice }}</div>
            </div> -->
            <!-- <div class="selb">
              <span>批发金额：</span>
              <div class="amountClass">{{ amendDuplication.tradePrice }}</div>
            </div> -->
          </div>
          <div class="child remorkBox">
            <div class="selb">
              <span>备注：</span>
              <el-input
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入内容"
                v-model="amendDuplication.productRemark"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="btnFlag"
          class="modifyCart"
          @click.stop="updateCpoyCart('修改')"
          >修改商品</el-button
        >
        <!-- <el-button
          :disabled="btnFlag"
          class="copyCart"
          @click.stop="updateCpoyCart('复制')"
          >复制商品</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOptional, getPlainPriceRange } from '@/api/detailsApi'
import { modifyCartPublic } from '@/api/cartApi'
import { deepClone } from '@/utils/util'
export default {
  props: {
    plainGoldSelectDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      optionsList: {},
      amendDuplication: {},
      btnFlag: false,
    }
  },
  mounted() {
    this.amendDuplication = deepClone(this.modifyingReplication)
    this.getOptional()
  },
  methods: {
    // 获取可选属性
    getOptional() {
      let obj = {
        styleNumber: this.amendDuplication.styleNumber,
        genderCode: this.amendDuplication.genderCode,
      }
      getOptional(obj).then((res) => {
        this.optionsList = res.data
      })
    },
    // 复制修改商品
    updateCpoyCart(text) {
      let type = ''
      let obj = {}
      if (text === '修改') {
        type = 'put'
      } else {
        obj = {
          productDtoList: [this.amendDuplication],
          shopType: 2,
          type: 2,
        }
        type = 'post'
      }
      modifyCartPublic(
        text === '修改' ? this.amendDuplication : obj,
        type
      ).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: text === '修改' ? '修改成功' : '复制成功',
            type: 'success',
            duration: 1500,
          })
          // 修改购物车数据
          this.$emit('updataCart')
          // 关闭弹窗
          this.$emit('onCloseSelectDialog')
        }
      })
    },
    //获取价格范围
    getPriceRange() {
      getPlainPriceRange(this.amendDuplication)
        .then((res) => {
          this.amendDuplication = { ...this.amendDuplication, ...res.data }
          this.btnFlag = false
        })
        .catch(() => {
          this.btnFlag = false
        })
    },
    // 延迟生效计算价格
    onBlur() {
      this.getPriceRange()
    },
    handleClose() {
      this.$emit('onCloseSelectDialog')
    },
  },
}
</script>

<style scoped lang="scss">
.ordinaryModify {
  ::v-deep .el-dialog {
    width: 900px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .ordinaryModifyChild {
    display: flex;
  }

  .copyImg {
    display: flex;
    align-items: center;
    margin-right: 5px;

    img {
      width: 100px;
      height: 100px;
    }
  }

  ::v-deep .el-select > .el-input {
    width: 300px;
  }

  .secBox {
    width: 100%;
  }

  .remorkBox {
    margin-top: 25px !important;
  }

  .child {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .selb {
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      width: 400px;

      .el-radio-group {
        margin-left: 20px;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #ec9368;
        background: #ec9368;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #ec9368;
      }

      span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        min-width: 70px;
        text-align: right;
      }
    }
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
  }
}

.cartTexture {
  font-size: 14px;
  width: 80px;
  text-align: center;
  margin: 5px 0 5px 15px;
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
}

.cartMainStone {
  font-size: 14px;
  width: 128px;
  text-align: center;
  margin: 5px 0 5px 15px;
  box-sizing: border-box;
  border: 1px solid #f0f0f0;
}

.cartColor {
  background: #ec9368;
  color: #fff;
}

.amountClass {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-select-dropdown__item {
  padding: 0;
  height: auto;
}

::v-deep .el-select-dropdown__list {
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}

::v-deep .el-input__inner {
  color: #ec9368;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}

::v-deep .el-input-number {
  width: 300px;
}

::v-deep .el-icon-minus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-icon-plus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-textarea__inner {
  width: 760px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-button span {
  font-size: 14px;
}

.modifyCart {
  background: #87ceeb;
  color: #fff;
  border: none;
}

.copyCart {
  background: #ec9368;
  color: #fff;
  border: none;
  margin-left: 20px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
</style>
